package pro.jayeshseth.animations.playground.utils

val BASE_FEATURE_ROUTE =
    "features/playground/src/main/kotlin/pro/jayeshseth/animations/playground"